import type {$Fetch} from "nitropack";

export interface BusinessProviderResponse {
  commission: {
    mission_id: string;
    employee_id: string;
    rate?: string; // Decimal represented as string
    created_at: string;
    updated_at: string;
  };
  employee: {
    employee_id: string;
    company_id: string;
    user_id: string;
    created_at: string;
    updated_at: string;
  };
  user: {
    user_id: string;
    email: string;
    firstname: string;
    lastname: string;
    created_at: string;
    updated_at: string;
  };
}

export interface UpdateBusinessProviderRateRequest {
  rate?: string; // Decimal represented as string
}

export interface UpdateBusinessProviderRateResponse {
  mission_id: string;
  employee_id: string;
  rate?: string; // Decimal represented as string
}

export const BusinessProviderRepository = (client: $Fetch) => ({
  getBusinessProvider: (missionId: string) => {
    return client(`/v1/missions/${missionId}/business_provider`, {
      method: 'GET'
    }) as Promise<BusinessProviderResponse>;
  },
  
  updateCommissionRate: (missionId: string, data: UpdateBusinessProviderRateRequest) => {
    return client(`/v1/missions/${missionId}/business_provider`, {
      method: 'PATCH',
      body: data
    }) as Promise<UpdateBusinessProviderRateResponse>;
  }
});